<template>
  <div>
    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'8-2'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>메뉴 관리 - 여행후기 관리</p>
          <div class="Admin_PageHeader_btn">
            <router-link to="/AdminTravelReviewManagementAdd" class="Admin_PageHeader_btn01">등록</router-link>
            <button class="Admin_PageHeader_btn02" v-on:click="edit">수정</button>
            <button class="Admin_PageHeader_btn03" v-on:click="delete_row">삭제</button>
          </div>
        </div>

        <div class="Admin_PageInner">
          <div class="Admin_PageInfo">
          </div>
          <div ref="table"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import {TabulatorFull as Tabulator} from 'tabulator-tables'
import {
  get_travel_review,
  delete_travel_review
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminTravelReviewManagement',
  components: {
    AdminHeader,
    AdminFooter
  },
  data () {
    return {
      tabulator: null
    }
  },
  methods: {
    edit: function () {
      if (this.tabulator.getSelectedData().length > 1) {
        alert('수정할 데이터를 하나만 선택해주세요.')
      } else if (this.tabulator.getSelectedData().length === 0) {
        alert('수정할 데이터를 선택해주세요.')
      } else {
        window.location.href = `/AdminTravelReviewManagementAdd?travel_review_ID=${this.tabulator.getSelectedData()[0].travel_review_ID}`
      }
    },
    delete_row: function () {
      let temp_delete_array = []
      this.tabulator.getSelectedData().forEach((element) => {
        temp_delete_array.push(element.travel_review_ID)
      })
      delete_travel_review(temp_delete_array).then((result) => {
        if (result === undefined) {
          alert('삭제가 되지 않았습니다. 관리자한테 확인해주세요.')
        } else {
          alert('삭제가 완료 되었습니다.')
          window.location.reload()
        }
      })
    }
  },
  mounted () {
    get_travel_review().then(result_data => {
      this.tabulator = new Tabulator(this.$refs.table, {
        data: result_data,
        layout: 'fitData',
        movableRows: true,
        columns: [
          {formatter: 'rowSelection',
            titleFormatter: 'rowSelection',
            headerSort: false,
            cellClick: function (e, cell) {
              cell.getRow().toggleSelect()
            }
          },
          {title: 'ID', field: 'travel_review_ID', headerSort: false},
          {title: '타이틀', field: 'travel_review_title', headerSort: false},
          {title: '상단공지', field: 'travel_review_top_status', headerSort: false},
          {title: '작성자', field: 'travel_review_write', headerSort: false},
          {title: '이메일', field: 'travel_review_email', headerSort: false},
          {title: '조회수', field: 'travel_review_views', headerSort: false},
          {title: '노출여부', field: 'travel_review_status', headerSort: false},
          {title: '댓글수', field: 'travel_review_comment_count', headerSort: false},
          {title: '작성일', field: 'travel_review_registe', headerSort: false},
          {title: '수정일', field: 'travel_review_modified', headerSort: false}
        ]
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/CommunityManagement/AdminTravelReviewManagement.vue